import { useState, MouseEvent, ReactElement, CSSProperties } from 'react';
import { Menu } from '@mui/material';

type ContextMenuProps = {
    children?: ReactElement | ReactElement[];
    menuItems?: (handleClose: () => void) => Array<ReactElement>;
    style?: CSSProperties;
    disabled?: boolean;
};

export default function ContextMenu({
    children,
    menuItems,
    style,
    disabled = false,
    ...props
}: ContextMenuProps) {
    const [contextMenu, setContextMenu] = useState<{
        mouseX: number;
        mouseY: number;
    } | null>(null);

    const handleContextMenu = (event: MouseEvent) => {
        event.stopPropagation();
        event.preventDefault();
        setContextMenu(
            contextMenu === null
                ? {
                      mouseX: event.clientX + 2,
                      mouseY: event.clientY - 6,
                  }
                : null,
        );
    };

    const handleClose = () => {
        setContextMenu(null);
    };

    return (
        <div
            onContextMenu={disabled ? undefined : handleContextMenu}
            style={{ ...{ width: '100%', height: '100%' }, ...style }}>
            {children}
            <Menu
                open={contextMenu !== null}
                onClose={handleClose}
                anchorReference="anchorPosition"
                anchorPosition={
                    contextMenu !== null
                        ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                        : undefined
                }>
                {menuItems && menuItems(handleClose)}
            </Menu>
        </div>
    );
}
